﻿import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import 'components/form-fields/FormFields.css';


export function FormHelperText(
    {
        loading = false,
        danger = false,
        children
    }
) {

	const [dangerValue, setDanger] = useState(false);

	useEffect(() => {
		const value = danger || false;
		setDanger(value);
	}, [danger]);

	if (!children || children === '') {
		return null;
	}

	return (
        <div className={classNames("helper-text", { "bp6-intent-danger": dangerValue, "bp6-skeleton": loading })}>
            {children}
        </div>
    );
}

FormHelperText.propTypes = {
	children: PropTypes.node,
	loading: PropTypes.bool,
	danger: PropTypes.bool
};